export default __webpack_public_path__ + "static/media/lauunch.f8afa65d.svg";